import { Pipe, type PipeTransform } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { injectEffectiveThemeFactory, RECRUITEE_THEME_DEFAULT } from '../types';

type StringContains<T extends string> = `${string}${T}${string}`;
export type ThemedImageTuple = [StringContains<'light'>, StringContains<'dark'>];

/** @nuggets
 *
 * Pipe that returns the appropriate themed image based on the current theme.
 * It listens to the effective theme changes and updates dynamically theme based assets.
 * ``` angular2html
 * <component
 *   [imageSrc]="[
 *   'assets/images/my_image_light.svg',
 *   'assets/images/my_image_dark.svg',
 *   ] | rtThemeImg"
 * />
 * ```
 */

@Pipe({
  name: 'rtThemeImg',
  pure: false,
})
export class ThemeImagePipe implements PipeTransform {
  private readonly theme = toSignal(injectEffectiveThemeFactory().effectiveThemeName$);

  public transform<T extends string | ThemedImageTuple>(value: T): string {
    if (typeof value === 'string') return value;
    const [light, dark] = value;
    return this.theme() === RECRUITEE_THEME_DEFAULT ? light : dark;
  }
}
